<template>
  <div id="app">
    <PcContainer v-if="isPC"></PcContainer>
    <MobileContainer v-else></MobileContainer>
  </div>
</template>

<script>
  import MobileDetect from "mobile-detect"
  import PcContainer from './views/container/PcContainer'
  import MobileContainer from './views/container/MobileContainer'
  export default {
    name: 'App',
    components: {
      PcContainer,
      MobileContainer
    },
    data() {
      return {
        isPC: true
      }
    },
    created() {
      var md = new MobileDetect(window.navigator.userAgent);

      if (md.phone()) {
        this.isPC = false;
      } else {
        this.isPC = true;
      }
    }
  }
</script>
<style>
  html,
  body {
    position: relative;
    height: 100%;
    font-family: 'Nanum Gothic', sans-serif;
  }

  body {
    
    margin: 0;
    padding: 0;
  }

  #app {
    width: 100%;
    height: 100%;
  }
  .swiper-container {
      width: 100%;
      height: 100%;
    }
</style>